import { BudgetType } from '../../shared/models/api/edu-expense.model';

export const budgetTypeTranslation: Readonly<Record<BudgetType | 'TOTAL' | 'CORRECTION', string>> =
  {
    [BudgetType.EDU]: 'EDU.TYPE.EDU',
    [BudgetType.EQU]: 'EDU.TYPE.EQU',
    TOTAL: 'EDU.TYPE.TOTAL',
    CORRECTION: 'EDU.TYPE.CORRECTION',
  };
